import { render } from "./MarqueeWithBackground.vue?vue&type=template&id=3aa7f718&scoped=true"
import script from "./MarqueeWithBackground.vue?vue&type=script&lang=js"
export * from "./MarqueeWithBackground.vue?vue&type=script&lang=js"

import "./MarqueeWithBackground.vue?vue&type=style&index=0&id=3aa7f718&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3aa7f718"]])

export default __exports__